import { FC, ReactNode } from 'react'

import { NativeCollapseMenuItem } from '~in-app/components/layout/console/native-sidebar/NativeCollapseMenuItem'
import { NativeMenuItem } from '~in-app/components/layout/console/native-sidebar/NativeMenuItem'
import { formatUrlPathname } from '~in-app/lib/utils'
import { MenuItemProps } from '~in-app/routerList'

interface MenuRenderProps {
  isSection?: boolean
  hasParent?: boolean
  name?: string
  label: ReactNode | string
  icon?: ReactNode | string
  path?: string
  items?: MenuItemProps[]
}

const NativeMenuRecursiveRender: FC<MenuRenderProps> = ({ isSection, icon, items, label, path, hasParent, name }) => {
  const hasItems = Array.isArray(items)

  if (isSection) {
    return (items || []).map((props, index) => (
      <NativeMenuRecursiveRender
        key={`MenuSection_${label}_${path}_${index}`}
        icon={props.icon}
        items={props.children}
        label={props.label}
        name={props.name}
        path={formatUrlPathname(path + (props.path || ''))}
      />
    ))
  }

  if (hasItems && items?.length > 0) {
    return (
      <NativeCollapseMenuItem
        icon={icon}
        items={items}
        label={label}
        name={name!}
        path={formatUrlPathname(path || '')}
      />
    )
  }

  return (
    <NativeMenuItem
      hasParent={hasParent}
      icon={icon}
      label={label}
      path={formatUrlPathname(path || '')}
    />
  )
}

export { NativeMenuRecursiveRender }
